module.exports = __webpack_public_path__ + "static/img/historyPageTopArea.6108b32.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/historyPageTopArea.png
// module id = fek0
// module chunks = 3